module.exports = __webpack_public_path__ + "static/media/mobile-clock-wallpaper.fe730b3d.jpg";